import { render, staticRenderFns } from "./ClaimsNumbers.vue?vue&type=template&id=71637da8"
import script from "./ClaimsNumbers.vue?vue&type=script&lang=js"
export * from "./ClaimsNumbers.vue?vue&type=script&lang=js"
import style0 from "./ClaimsNumbers.vue?vue&type=style&index=0&id=71637da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports